import React from 'react';
import useStyles from './styles';
import { IBaseActionButtonProps } from '../interfaces';
import BaseActionButton from '../BaseActionButton';
import { ReactComponent as PlusIcon } from '../../../../assets/icons/plus.svg';
import theme from '../../../../styles/theme';

const AddActionButton = (props: IBaseActionButtonProps) => {
  const { classes } = useStyles(theme);

  return (
    <BaseActionButton
      {...props}
      styles={{
        border: `1px solid ${theme.palette.primary.main}`,
        '&:disabled': {
          borderColor: `${theme.palette.background.default} !important`,
        },
      }}>
      <PlusIcon />
    </BaseActionButton>
  );
};

export default AddActionButton;
